import React, { useEffect } from 'react';
import { useDatadogLog } from '@/hooks/useDatadogLog';
import { computeAccessibleName } from 'dom-accessibility-api';

export default function NativeButtonLogger({ children }: { children: React.ReactNode }) {
  const { datadogLog } = useDatadogLog();

  function handleClick(e: MouseEvent) {
    const button = e.target as HTMLElement;
    if (button.dataset.custom === 'true') return;
    if (button.nodeName !== 'BUTTON') return;

    let payload = {};
    const label = computeAccessibleName(button);
    if (label) {
      payload = { name: label, label };
    }

    datadogLog({
      message: `${label} was clicked`,
      payload,
      actionType: 'Button',
    });
  }

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return <>{children}</>;
}
